<template lang="html">
  <div class="page-header">
    <BrandBar
      slot="header"
      :home-url="`/${locale.columns.country}/${locale.columns.language}`"
      :logo-image="logoImage"
    >
      <slot slot="announcement" name="announcement" />
      <div class="page-header__navigation">
        <MainNavigation
          :items="navigationItems"
        />
      </div>
      <div
        slot="actions"
        class="page-header__actions"
      >
        <IconBar
          :items="navigationActions"
        />
      </div>
      <div
        slot="toggle"
        class="page-header__toggle"
      >
        <Button
          type="bare"
          class="page-header__toggle"
          @click="$store.commit('ui/toggleOffscreen')"
        >
          <MenuIcon slot="before" />
          <span class="page-header__toggle-label">Menu</span>
        </Button>
      </div>
      <div
        slot="additional"
        class="page-header__locales-switch"
      >
        <LocalesSwitcher :countries="countries" :country="country" :locale="locale" :locales="locales" />
      </div>
    </BrandBar>
  </div>
</template>

<script>
import BrandBar from 'beisheim/components/elements/brand-bar'
import MainNavigation from 'beisheim/components/elements/main-navigation'
import IconBar from 'beisheim/components/elements/icon-bar'
import Button from 'beisheim/components/elements/button'
import LocalesSwitcher from 'beisheim/components/elements/locales-switcher'
import MenuIcon from 'beisheim/assets/images/icons/beisheim-stiftung-menu.svg'

export default {
  components: {
    BrandBar,
    MainNavigation,
    IconBar,
    MenuIcon,
    Button,
    LocalesSwitcher
  },
  props: {
    logoImage: {
      type: String,
      required: true
    },
    navigationItems: {
      type: Array,
      required: true
    },
    navigationActions: {
      type: Array,
      required: true
    },
    country: {
      type: Object,
      default: () => ({})
    },
    countries: {
      type: Array,
      default: () => []
    },
    locale: {
      type: Object,
      default: () => ({})
    },
    locales: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/breakpoints';
@import 'beisheim/scss/scale';
@import 'beisheim/scss/colors';

.page-header {
  background-color: #fff;
  z-index: 1;
}

.page-header__navigation {
  display: none;

  @include from(4) {
    display: block;
  }
}

.page-header__actions {
  display: none;
  border-right: 2px solid gray(4);
  padding: 0 .8rem;

  @include from(3) {
    margin-right: scale(1);
    margin-left: scale(1);
    display: flex;
    align-items: center;
  }

  @include at(4) {
    margin: 0;
    padding: 0;
  }
}

.page-header__toggle {
  display: flex;
  align-items: center;

  @include from(4) {
    display: none;
  }
}

.page-header__toggle-label {
  @include to(3) {
    display: none;
  }
}

.page-header__locales-switch {
  display: none;

  @include from(4) {
    display: flex;
    align-items: center;
  }
}
</style>
